<template>
	<div class="wrap">
		<div class="container">
			<div v-show="!show1">
				<h3 class="personal_titile">在此找回密码</h3>
				<div class="adddz chardz">
					<div class="address_require">
						<label>邮件地址<span>*</span></label>
						<input type="text" maxlength="50" v-model="email" >
					</div>
					<div class="retrieve-set">
						<p>请输入您注册的邮件地址.</p>
						<p>您将收到我们系统自动发送的电子邮件，这将帮助您重置您的密码.</p>
					</div>
					<van-row type="flex" justify="space-between">
						<van-col span="12">
							<van-button style="width: 92px;" to="/login" size="small" color="#000" type="primary">返回登录</van-button>
						</van-col>
						<van-col span="12">
							<van-button style="width: 92px;" class="fr" size="small" type="primary" @click="change">确认</van-button>
						</van-col>
					</van-row>
				</div>
			</div>
			<div class="page-title" v-show="show1">
				<h1 style="color:#000000;margin-bottom: 50px;"> 发送成功!</h1>
				<p>请检查您的邮件帐户.</p>
				<p>一封电子邮件已发送至 <span style="color:#000000;">{{email}}</span>. 请遵循电子邮件中设置新密码的说明.</p>
				<p>如果没有收到我们的邮件？检查你的垃圾邮件文件夹.</p>
			</div>
		</div>
		<v-foot></v-foot>
	</div>
</template>

<script>
	var _this;
	// @ is an alias to /src
	export default {
		components: {},
        created(){
			_this = this;
        },
		data() {
			return {
				show1:false,
				email:"",
			}
		},
		methods: {
			change() {
				this.POST("api/user/forgetpwdverifysend",{"accounts":this.email},function(d){
					if(d.code != 0){
						_this.$toast(d.msg);
					}else{
						_this.show1 = true;
					}
				});
			}
		},
	}
</script>